import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Marketday } from './marketday.model';
import { MarketdayPopupService } from './marketday-popup.service';
import { MarketdayService } from './marketday.service';
import { Marketplace, MarketplaceService } from '../marketplace';
import { Contact, ContactService } from '../contact';
import { Branch, BranchService } from '../branch';

@Component({
    selector: 'jhi-marketday-dialog',
    templateUrl: './marketday-dialog.component.html'
})
export class MarketdayDialogComponent implements OnInit {

    marketday: Marketday;
    authorities: any[];
    isSaving: boolean;

    marketplaces: Marketplace[];

    contacts: Contact[];

    branches: Branch[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private marketdayService: MarketdayService,
        private marketplaceService: MarketplaceService,
        private contactService: ContactService,
        private branchService: BranchService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketday', 'marketOperation', 'weekday']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketplaceService.query().subscribe(
            (res: Response) => { this.marketplaces = res.json(); }, (res: Response) => this.onError(res.json()));
        this.contactService.query().subscribe(
            (res: Response) => { this.contacts = res.json(); }, (res: Response) => this.onError(res.json()));
        this.branchService.query().subscribe(
            (res: Response) => { this.branches = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.marketday.id !== undefined) {
            this.marketdayService.update(this.marketday)
                .subscribe((res: Marketday) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.marketdayService.create(this.marketday)
                .subscribe((res: Marketday) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: Marketday) {
        this.eventManager.broadcast({ name: 'marketdayListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackMarketplaceById(index: number, item: Marketplace) {
        return item.id;
    }

    trackContactById(index: number, item: Contact) {
        return item.id;
    }

    trackBranchById(index: number, item: Branch) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-marketday-popup',
    template: ''
})
export class MarketdayPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketdayPopupService: MarketdayPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.marketdayPopupService
                    .open(MarketdayDialogComponent, params['id']);
            } else {
                this.modalRef = this.marketdayPopupService
                    .open(MarketdayDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketday/marketday-dialog.component.ts